import { Link } from "react-router-dom";

/** Slugify a team name into the URL form used by /team/<slug>. */
export const teamSlug = (name) => {
  if (!name) return "";
  return name
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

/**
 * <TeamLink name="Arsenal">Arsenal</TeamLink>
 *  → <Link to="/team/arsenal">Arsenal</Link>
 *
 * Drop-in replacement for plain team-name strings anywhere in the app
 * to make every name a shareable permalink.  Falls back to plain text
 * if the slug can't be derived.
 */
export const TeamLink = ({ name, className = "", children, onClick }) => {
  const slug = teamSlug(name);
  if (!slug) return <span className={className}>{children || name}</span>;
  return (
    <Link
      to={`/team/${slug}`}
      className={`hover:underline underline-offset-4 ${className}`}
      onClick={onClick}
      data-testid={`team-link-${slug}`}
    >
      {children || name}
    </Link>
  );
};

export default TeamLink;
